/**
 * Toast — Animated top-center snackbar notification with icon
 */
import React from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

export default function Toast({ open, message, severity = 'success', onClose, duration = 4000 }) {
  const severityColors = {
    success: { bg: '#1b5e20', shadow: 'rgba(27,94,32,0.4)' },
    error:   { bg: '#b71c1c', shadow: 'rgba(183,28,28,0.4)' },
    warning: { bg: '#e65100', shadow: 'rgba(230,81,0,0.4)' },
    info:    { bg: '#0d47a1', shadow: 'rgba(13,71,161,0.4)' },
  };
  const colors = severityColors[severity] || severityColors.info;

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={SlideTransition}
      sx={{ top: { xs: 16, sm: 24 } }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          width: '100%',
          minWidth: 320,
          borderRadius: 2.5,
          fontWeight: 600,
          fontSize: '0.9rem',
          boxShadow: `0 8px 32px ${colors.shadow}`,
          '& .MuiAlert-icon': { fontSize: 22 },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
